module.exports = __webpack_public_path__ + "media/images/dhl-73dbe39c3c870c23e982431db79b430e.svg";